module.exports = __webpack_public_path__ + "img/profitability4.16749be4.png";